/* 🤖 this file was generated by svg-to-ts */
export const matIconMoving: {
  name: 'moving';
  data: string;
} = {
  name: 'moving',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 9.42V12h2V6h-6v2h2.58l-4.46 4.46a.996.996 0 0 1-1.41 0l-1.17-1.17a3 3 0 0 0-4.24 0L2 16.59 3.41 18l5.29-5.29a.996.996 0 0 1 1.41 0l1.17 1.17a3 3 0 0 0 4.24 0L20 9.42z"/></svg>`
};
